var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{staticClass:"font-weight-bold p-4 rounded mr-auto",attrs:{"type":"outline-secondary","size":"lg"},on:{"click":function($event){return _vm.$store.dispatch(_vm.CommActions.SendTestEmail)}}},[_c('Icon',{staticClass:"mr-2",attrs:{"icon":"location-arrow"}}),_vm._v(" Send a test email to myself ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }